export enum OBannerFeatureContentAlignment {
  Left = 'Left',
  Center = 'Centered',
}

export enum OBannerFeatureLayout {
  Default = 'Default',
  Reverse = 'Reverse',
}

export interface OBannerFeatureTextBlockSimple {
  aEyebrow?: {
    eyebrowText?: string | null;
  };
  aHeader?: {
    text?: string | null;
    size?: string | null;
    headerTag?: string | null;
  };
  aBody?: {
    bodyText?: string | null;
    size?: string | null;
    color?: string | null;
  };
}

export interface OBannerFeatureButton {
  buttonText?: string | null;
  type?: string | null;
  ctaLink?: string | null;
  openInANewTab?: string | null;
}

export interface OBannerFeatureImage {
  image?: {
    damPath?: string;
    assetPath?: string;
    altText?: string;
    dynamic?: boolean;
    enableSmartCrop?: boolean;
  };
}

export interface OBannerFeatureProps {
  contentAlignment?: OBannerFeatureContentAlignment;
  layout?: OBannerFeatureLayout;
  mTextBlockSimple?: OBannerFeatureTextBlockSimple;
  mButton?: OBannerFeatureButton;
  aImage?: OBannerFeatureImage;
}
